import React from 'react';
import { Box, Modal, Typography, IconButton, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ToolsModal = ({ open, handleClose, tool }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxHeight: '80%',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
        }}
      >
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ fontWeight: 'bold', color: 'primary.main' }}
          >
            Tool Details
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box id="modal-description" sx={{ mt: 3 }}>
          {tool ? (
            <>
              {/* Details Section */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  Overview
                </Typography>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 2fr',
                    gap: 1,
                    alignItems: 'start',
                  }}
                >
                  <Typography variant="body2" color="text.secondary">
                    <strong>Timestamp:</strong>
                  </Typography>
                  <Typography variant="body2">{tool.created_at}</Typography>

                  {/* Assets */}
                  <Typography variant="body2" color="text.secondary">
                    <strong>Assets:</strong>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      backgroundColor: '#f5f5f5',
                      border: '1px solid #e0e0e0',
                      padding: '10px',
                      borderRadius: '4px',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {tool.assets_data &&
                      JSON.parse(tool.assets_data)
                      .map((asset) => asset.host + ':' + asset.port)
                      .join(', ')}
                  </Typography>

                  {/* Exploits */}
                  <Typography variant="body2" color="text.secondary">
                    <strong>Exploits:</strong>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      backgroundColor: '#f5f5f5',
                      border: '1px solid #e0e0e0',
                      padding: '10px',
                      borderRadius: '4px',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {tool.exploits_data &&
                      JSON.parse(tool.exploits_data)
                        .map((exploit) => exploit.exploit)
                        .join(', ')}
                  </Typography>
                </Box>
              </Box>

              {/* Command Section */}
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  Command
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #e0e0e0',
                    padding: '10px',
                    borderRadius: '4px',
                    fontFamily: 'monospace',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {tool.command}
                </Typography>
              </Box>

              {/* Command Output Section */}
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  Output
                </Typography>
                <Paper
                  elevation={1}
                  sx={{
                    backgroundColor: '#f5f5f5',
                    padding: '10px',
                    borderRadius: '4px',
                    fontFamily: 'Courier, monospace',
                    fontSize: '14px',
                    whiteSpace: 'pre-wrap',
                    overflow: 'auto',
                  }}
                >
                  {tool.output || 'No output available'}
                </Paper>
              </Box>
            </>
          ) : (
            <Typography>No tool details available.</Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ToolsModal;
